module.exports = __webpack_public_path__ + "img/top-bg.97652f99.png";